import React from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { brand, tailwindColors } from "../theme/gitoColors";

const SelectDropdown = ({
    options,
    selectedValues,
    onChange,
    placeholder,
    label = "",
    isMulti = true,
    isInvalid = false,
    invalidMessage,
    disabled = false,
    required = false,
    formatOptionLabel = "",
    isClearable = false,
}) => {
    const { t } = useTranslation();
    const customStyles = {
        control: (styles, state) => ({
            ...styles,
            borderColor: isInvalid ? tailwindColors.error[600] : styles.borderColor,
            boxShadow: isInvalid
                ? `0 0 0 1px ${tailwindColors.error[600]}`
                : state.isFocused
                    ? styles.boxShadow
                    : "none",
            "&:hover": {
                borderColor: isInvalid
                    ? tailwindColors.error[600]
                    : styles["&:hover"]?.borderColor,
            },
        }),
        multiValue: (styles) => ({
            ...styles,
            backgroundColor: tailwindColors.primary[300],
            color: brand.darkBlue,
            borderRadius: "12px",
            padding: "2px 8px",
            fontWeight: "600",
        }),
        multiValueLabel: (styles) => ({
            ...styles,
            color: brand.darkBlue,
            padding: 0,
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: brand.darkBlue,
            cursor: "pointer",
            ":hover": {
                backgroundColor: tailwindColors.volt[800],
                color: brand.white,
            },
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 99999,
        }),
    };

    return (
        <div className="flex flex-col w-full">
            {label && (
                <label className="block text-sm font-bold mb-2">
                    {label}
                    {required && <span className="text-red-500 ml-1">*</span>}
                </label>
            )}
            <Select
                options={options}
                value={selectedValues}
                onChange={onChange}
                isMulti={isMulti}
                placeholder={placeholder ?? t("dropdown.choose")}
                closeMenuOnSelect={!isMulti}
                styles={customStyles}
                className={isInvalid ? "input-invalid" : ""}
                isDisabled={disabled}
                formatOptionLabel={formatOptionLabel}
                isClearable={isClearable}
                menuPortalTarget={document.body}
                menuPosition="fixed"
            />
            {isInvalid && (
                <span className="text-xs text-error-400">
                    {invalidMessage ??
                        (label
                            ? t("dropdown.required", { label })
                            : t("common.required"))}
                </span>
            )}
        </div>
    );
};

export default SelectDropdown;
